import { matchPath } from "react-router-dom";
import { PATHNAMES } from "../../../utils/admin-routing-utils";
import store from '../../../store/main';

export const getNamespaceAdmin = () => {
	const match = matchPath<{ id: string, customPath?: string, session?: string, language: string }>(window.location.pathname, [
		PATHNAMES.Event.Landing,
		PATHNAMES.Event.HomePath,
		PATHNAMES.Event.CustomPage,
		PATHNAMES.Session.Session
	]);

	if (match) {
		const event = store.getState().CreateEventReducer?.workingEvent;

		if (match.params.language === event?.settings?.i18n?.base) {
			return 'homepage';
		}

		if (match.path === PATHNAMES.Event.Landing) {
			return 'landing';
		} else if (match.path === PATHNAMES.Event.HomePath) {
			return 'home';
		} else if (match.path === PATHNAMES.Session.Session) {
			const id = match.params.session as string;
			const session = event?.sessions?.find(session => session.uuid === id);
			return `session.${session?.session}`;
		} else if (match.path === PATHNAMES.Event.CustomPage) {
			const customPath = match.params.customPath as string;
			const page = event?.custom_pages?.find(page => page.path === customPath);
			return `custom_page.${page?.custom_page}`;
		}
	}

	return "homepage";
};

export const isBrandliveEmail = (email: string) => {
	return email.endsWith('@brandlive.com');
};
